import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DateInput, Button, Loader } from 'kangarootime-ui';
import moment from 'moment';
import ChannelGroupsDropdown from './ChannelGroupsDropdown';
import UserSelectDropdown from './UserSelectDropdown';
import './SearchFilters.css';

const SearchFilters = ({
  channels,
  users,
  performSearchQuery,
  fetchingUsers,
  fetchingChannels,
  currentQuery,
  performingQuery,
  ...props
}) => {
  const [selectedChannel, setSelectedChannel] = currentQuery.channelIds && currentQuery.channelIds.length ? useState(currentQuery.channelIds[0]) : useState(-1);
  const [selectedUser, setSelectedUser] = currentQuery.selectedUserId ? useState(currentQuery.selectedUserId) : useState(-1);
  const [startDate, setStartDate] = currentQuery.startDate ? useState(moment(currentQuery.startDate).format('YYYY-MM-DD')) : useState(moment().subtract(1, 'day').format('YYYY-MM-DD'));
  const [endDate, setEndDate] = currentQuery.endDate ? useState(moment(currentQuery.endDate).format('YYYY-MM-DD')) : useState(moment().format('YYYY-MM-DD'));

  return (
    <div className='search-filters-container' style={{ margin: 8 }}>
      <ChannelGroupsDropdown
        channels={channels}
        onSelect={event => setSelectedChannel(event.target.value)}
        selectedChannelId={selectedChannel}
      />
      <Loader loading={fetchingUsers}>
        <UserSelectDropdown
          users={users}
          onSelect={event => setSelectedUser(event.target.value)}
          selectedUserId={selectedUser}
        />
      </Loader>
      <DateInput
        label='Start Date'
        value={startDate}
        onChange={event => setStartDate(event.target.value)}
      />
      <DateInput
        label='End Date'
        value={endDate}
        onChange={event => setEndDate(event.target.value)}
      />
      <div className='flex-columns' style={{ justifyContent: 'flex-end' }}>
        <Button
          type='secondary'
          disabled={performingQuery}
          onClick={() => performSearchQuery({
            channelIds: parseInt(selectedChannel, 10) === -1 ? [] : [selectedChannel],
            senderId: parseInt(selectedUser, 10) === -1 ? '' : selectedUser,
            startDate,
            endDate
          })}
        >
          Search
        </Button>
      </div>
    </div>
  );
};

SearchFilters.propTypes = {
  channels: PropTypes.array,
  users: PropTypes.shape({
    parents: PropTypes.array,
    employees: PropTypes.array
  }),
  performSearchQuery: PropTypes.func,
  fetchingUsers: PropTypes.bool,
  fetchingChannels: PropTypes.bool,
  currentQuery: PropTypes.object,
  performingQuery: PropTypes.bool
};

export default SearchFilters;
